module.exports = __webpack_public_path__ + "media/newstyle/images/icon-open-chart-orange-6b97f4423913556e670a060c3ac05b80.svg";